import { render } from "./LbrxButtonIcon.vue?vue&type=template&id=315af928&scoped=true"
import script from "./LbrxButtonIcon.vue?vue&type=script&lang=js"
export * from "./LbrxButtonIcon.vue?vue&type=script&lang=js"

import "./LbrxButtonIcon.vue?vue&type=style&index=0&id=315af928&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-315af928"]])

export default __exports__